import { reducer as reports } from "./reports/slice";

export const reducer = {
  reports,
};
